/* eslint-disable react/prop-types */
import { Button } from "@mui/material";
import { AiLogoButton } from "./index";

export default function StickyIcon({ handleOpen, color }) {
  const size = "2.5em";
  return (
    <Button
      variant="text"
      sx={{
        width: { size },
        height: { size },
        padding: 0,
        minWidth: 0,
        borderRadius: 3,
        position: "fixed",
        top: "30%",
        right: "0.5%",
        zIndex: "1300",
      }}
      onClick={handleOpen}
      data-dtm="exhibitorHub_smartCompanion_popupIcon"
    >
      <AiLogoButton color={color} sx={{ height: size, width: size }} />
    </Button>
  );
}
